export default __webpack_public_path__ + "static/media/updapt-logo-green.f49fc6e4.png";